export const SPED_CST_CONSULTA_URL =
  'http://www.sped.fazenda.gov.br/spedtabelas/AppConsulta/publico/aspx/ConsultaTabelasExternas.aspx?CodSistema=SpedFiscal';

export const CST_PIS_DOC_URL = 'http://sped.rfb.gov.br/arquivo/download/1629';
export const CST_COFINS_DOC_URL = 'http://sped.rfb.gov.br/arquivo/download/1630';

export const CST_GOLDEN_ICMS_TRIBUTADA = '00';
export const CST_GOLDEN_ICMS_ST = '10';
export const CST_GOLDEN_IPI_SAIDA = '50';
export const CST_GOLDEN_IPI_ENTRADA = '00';
export const CST_GOLDEN_PIS_TRIBUTAVEL = '01';
export const CST_GOLDEN_PIS_ISENTA = '07';
export const CST_GOLDEN_COFINS_TRIBUTAVEL = '01';
export const CST_GOLDEN_COFINS_ISENTA = '07';

export const CST_MIN_ICMS = 10;
export const CST_MAX_ICMS = 20;
export const CST_MIN_IPI = 12;
export const CST_MAX_IPI = 20;
export const CST_MIN_PIS = 30;
export const CST_MAX_PIS = 40;
export const CST_MIN_COFINS = 30;
export const CST_MAX_COFINS = 40;
